import { useCreateGroupMutation } from '../graphql/mutations/generated/createGroup';
import { useCreateUserCollectionGroupMutation } from '../graphql/mutations/generated/createUserCollectionGroup';
import { useUpdateGroupMutation } from '../graphql/mutations/generated/updateGroup';
import { useUpdateUserCollectionGroupMutation } from '../graphql/mutations/generated/updateUserCollectionGroup';

function useCreateAndUpdateGroup() {
  const [createdGroup, executeCreateGroup] = useCreateUserCollectionGroupMutation();
  const [createdCollection, executeCreateCollection] = useCreateGroupMutation();
  const [updatedGroup, executeUpdateGroup] = useUpdateUserCollectionGroupMutation();
  const [updatedCollection, executeUpdateCollection] = useUpdateGroupMutation();

  return {
    createGroup: executeCreateGroup,
    updateGroup: executeUpdateGroup,
    fetchingGroup: createdGroup.fetching || updatedGroup.fetching,
    createCollection: executeCreateCollection,
    updateCollection: executeUpdateCollection,
    fetchingCollection: createdCollection.fetching || updatedCollection.fetching,
  };
}

export default useCreateAndUpdateGroup;
